import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
  imageFormatter,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getBanners,
  deleteBanner,
  changeStatusBanner,
  changeOrderBanner,
} from "../../../../api/banner";
import { Button, Tooltip, Switch, FormControlLabel, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { getLocalidades } from "../../../../api/localidad";
import { getNonEmpty } from "../../../../utils/helpers";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  VerifiedUser,
} from "@material-ui/icons";
import { Verified } from "lucide-react";

function getData(banners) {
  let data = [];
  for (let i = 0; i < banners.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(banners[i].titulo);
    elem.imageCa = banners[i].imageUrl?.ca;
    elem.imageEs = banners[i].imageUrl?.es;
    elem.id = banners[i]._id;
    elem.active = banners[i].active;
    elem.order = banners[i].order;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.order - b.order);
  return data;
}

const initialFilters = {
  active: false,
};

export default function BannersPage() {
  const [data, setData] = useState([]);
  const [bannerId, setBannerId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem('bannersPage_searchText');
    return saved || '';
  });
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  async function cambiarOrden(cell, newOrder) {
    await changeOrderBanner(cell, newOrder);
  }
  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const handleSubtract = () => {
      setData((prevFilteredData) => {
        const currentBanner = prevFilteredData.find(
          (banner) => banner._id === cell
        );
        if (!currentBanner || currentBanner.order === 0)
          return prevFilteredData;

        const newOrder = currentBanner.order - 1;
        cambiarOrden(currentBanner._id, newOrder);

        const bannerToSwap = prevFilteredData.find(
          (banner) => banner.order === newOrder
        );

        return prevFilteredData.map((banner) => {
          if (banner._id === cell) {
            return { ...banner, order: newOrder };
          }
          if (bannerToSwap && banner._id === bannerToSwap._id) {
            return { ...banner, order: currentBanner.order };
          }
          return banner;
        });
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setData((prevFilteredData) => {
        const currentBanner = prevFilteredData.find(
          (banner) => banner._id === cell
        );
        if (
          !currentBanner ||
          currentBanner.order === prevFilteredData.length - 1
        )
          return prevFilteredData;

        const newOrder = currentBanner.order + 1;
        cambiarOrden(currentBanner._id, newOrder);
        const bannerToSwap = prevFilteredData.find(
          (banner) => banner.order === newOrder
        );

        return prevFilteredData.map((banner) => {
          if (banner._id === cell) {
            return { ...banner, order: newOrder };
          }
          if (bannerToSwap && banner._id === bannerToSwap._id) {
            return { ...banner, order: currentBanner.order };
          }
          return banner;
        });
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === data.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-banner/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBannerId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBannerId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "titulo", text: "Titulo", sort: true },
    { dataField: "imageEs", text: "Image ES", formatter: imageFormatter },
    { dataField: "imageCa", text: "Image CA", formatter: imageFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getBanners();
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      } catch (error) {
        alertError({ error: error, customMessage: "Could not get banners." });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText('');
    localStorage.removeItem('bannersPage_searchText');
    localStorage.removeItem('bannersPage_currentPage');
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Primera fila: Campo de búsqueda */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('bannersPage_searchText', value);
                } else {
                  localStorage.removeItem('bannersPage_searchText');
                }
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de banners">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-banner")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && !refreshOrder && (
            <Table 
              data={getData(data)} 
              columns={columns} 
              pageKey="bannersPage"
              searchText={searchText}
              onSearchChange={(value) => {
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('bannersPage_searchText', value);
                } else {
                  localStorage.removeItem('bannersPage_searchText');
                }
              }}
            />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              bannerId?.active ? "disable" : "enable"
            } this banner?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusBanner(bannerId._id, !bannerId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${bannerId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        bannerId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      bannerId?.active ? "disable" : "enable"
                    } banner.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this banner?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteBanner(bannerId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Banner removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove banner.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
